import React from 'react';
import TreatmentConsentLandingPage from './TreatmentConsentLandingPage';

export default function ToothExtractionConsentFormUk() {
  return (
    <TreatmentConsentLandingPage
      title="Tooth Extraction Consent Form UK | Digital Dental Consent | Smile Consent"
      description="Create a tooth extraction consent form for UK dental practices with AI-assisted drafting, digital signing, and clearer records for routine or surgical extraction."
      canonicalUrl="https://smileconsent.co.uk/tooth-extraction-consent-form-uk"
      h1="Tooth Extraction Consent Form for UK Practices"
      treatmentName="Tooth extraction consent form"
      intro="Create tooth extraction consent forms for routine and surgical cases with digital signing, clear risk disclosure, and a stronger audit trail for UK practices."
      risks={[
        'Why extraction is proposed, expected benefits, and whether alternatives remain available.',
        'Material risks such as pain, bleeding, swelling, infection, dry socket, retained roots, or damage to nearby teeth and restorations.',
        'Specific surgical risks including sinus involvement, nerve injury, or the need for referral where clinically relevant.',
        'Post-operative instructions, healing expectations, review arrangements, and warning signs after treatment.',
        'Treatment costs, likely time away from normal activity, and any further restorative plan after extraction.',
      ]}
      officialGuidanceLinks={[
        {
          title: 'NICE TA1 — guidance on the extraction of wisdom teeth',
          description:
            'Useful when discussing surgical or wisdom tooth removal: NICE evidence-based recommendations for UK practice.',
          href: 'https://www.nice.org.uk/guidance/ta1',
          ctaLabel: 'Open on NICE',
        },
        {
          title: 'SDCEP — antibiotic prophylaxis against infective endocarditis',
          description:
            'When patients have relevant cardiac history: SDCEP implementation advice on at-risk procedures (including extractions), shared decision-making, and prescribing.',
          href: 'https://www.antibioticprophylaxis.sdcep.org.uk/implementation-advice/introduction/main-changes-in-this-edition/',
          ctaLabel: 'Open SDCEP advice',
        },
      ]}
      relatedLinks={[
        {
          title: 'SDCEP: infective endocarditis prophylaxis',
          description: 'Official links and second-edition changes — read before relevant cases',
          path: '/sdcep-infective-endocarditis-prophylaxis',
        },
        { title: 'Root canal consent form UK', description: 'Consent wording when endodontic treatment is an alternative', path: '/root-canal-consent-form-uk' },
        { title: 'Implant consent form UK', description: 'Consent records for replacement options after extraction', path: '/implant-consent-form-uk' },
        { title: 'AI dental consent forms', description: 'See all treatment-specific consent workflows', path: '/dental-consent-forms' },
      ]}
    />
  );
}
